"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useStyles = function (theme) { return ({
    "invosys-ui-Navigation-navContainer": {
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        marginBottom: "1.5rem"
    },
    "invosys-ui-Navigation-navContainer-dense": {
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        marginBottom: "0.5rem"
    },
    "invosys-ui-Navigation-tab": {
        "&:hover, &:focus": {
            borderBottom: "2px solid " + theme.palette.primary.main
        }
    }
}); };
exports.default = useStyles;
